import React from 'react';
import { ColDef } from 'ag-grid-community';
import { buildColDefFromColumnDefinition } from '@instinet-analytics/semantic-ui-components';
import { IndigoAppContextType } from 'app/AppContext';
import { numberFormatUtils } from '@instinet-analytics/core-lib';
import {
    ExpertiseColumn,
    expertiseColumnDefinitions,
} from 'widgets/expertise/ExpertiseColumnDefinitions';

const { N2to4 } = numberFormatUtils;

const expertiseMakeColumns: ExpertiseColumn[] = [
    'dateTime',
    'orderId',
    'venueName',
    'size',
    'price',
    'aggressionLevel',
    'algoType',
    'askPlus1Price',
    'askPlus1Size',
    'askPrice',
    'askSize',
    'bidMinus1Price',
    'bidMinus1Size',
    'bidPrice',
    'bidSize',
    'bindingPriceRuleOrReason',
    'brokerName',
    'brokerRealTimeFairValue',
    'childDisplayedQty',
    'childMinAcceptQty',
    'childOrderId',
    'childOrderPriceLimit',
    'childOrderTIF',
    'childOrderType',
    'darkPoolPosting',
    'date',
    'dFARealTimeFairValue',
    'eventType',
    'exchCounterCode',
    'executionPrice',
    'executionSize',
    'indexPctChange',
    'indexReferencePrice',
    'indexRelOffset',
    'indexRelReference',
    'indexValue',
    'iNetMaxRollingPart',
    'iNetMTVProbability',
    'iNetRollingPartWindow',
    'iNetRollingVolumeType',
    'iNetUseHistoricalVolume',
    'iRELRollingWindowMin',
    'lastTradePrice',
    'lastTradeSize',
    'lastTradeTime',
    'maxExposurePerVenue',
    'maxPctVolume',
    'orderLevel',
    'parentOrderState',
    'parentPrimaryPriceLimit',
    'predictedRemainMktVol',
    'reloadAndRefreshDelay',
    'reloadTriggerSeconds',
    'residual',
    'secondaryPriceLimit',
    'seq',
    'smallResidualMin',
    'smallTradeMinimization',
    'stockIRLimit',
    'stockPrimaryBBGCode',
    'stockReferencePrice',
    'tactic',
    'tradeInClose',
    'tradeInOpen',
    'venueType',
    'venueVolInLimit',
    'vWAPVolumeAll',
    'way',
];

export const columnDefs: (context: IndigoAppContextType) => ColDef[] = (
    context
) =>
    expertiseMakeColumns.map((id) => {
        const columnDefinition = expertiseColumnDefinitions[id];
        const colDef = buildColDefFromColumnDefinition(
            context,
            id,
            columnDefinition
        );
        if (
            columnDefinition === expertiseColumnDefinitions.iNetMTVProbability
        ) {
            colDef.cellRenderer = getMtvColCellRenderer(context);
        }
        return colDef;
    });

function getMtvColCellRenderer(context: IndigoAppContextType) {
    // eslint-disable-next-line react/display-name
    return (props: { value: number | string | undefined }) => {
        if (props.value === undefined) {
            return '<span/>';
        }
        if (typeof props.value === 'string') {
            return <span>${props.value}</span>;
        }

        return <span>${N2to4(context, props.value)}</span>;
    };
}
